import { formatChinaDateTime } from "../time";

type RecordItem = {
  id:string; name:string; created_at:string; status:string; charged:string;
  statistics:Record<string,number>;
  products:{code:string;name:string;count:number;processed:number}[];
};
const labels:Record<string,string> = {READY:'待提交',QUEUED:'等待执行',RUNNING:'查询中',TRIAL_DONE:'试查完成',COMPLETED:'已完成',REVIEW:'待核实',STOPPED:'已终止'};

export function BatchHistory<T extends RecordItem>({ jobs, onOpen, onDownload }: {
  jobs:T[]; onOpen:(job:T)=>void; onDownload:(job:T,code:string,name:string)=>void;
}) {
  return <div className="batch-table-wrap"><table className="batch-history"><thead><tr>
    <th>创建时间</th><th>任务名称</th><th>产品</th><th>有效数据</th><th>执行状态</th><th>实际费用</th><th>操作</th>
  </tr></thead><tbody>{jobs.map(job => {
    const total = job.products.reduce((n,p)=>n+p.count,0);
    const done = job.products.reduce((n,p)=>n+p.processed,0);
    const progress = total ? Math.min(100,Math.round(done/total*100)) : 0;
    const downloadable = ['TRIAL_DONE','COMPLETED','REVIEW','STOPPED'].includes(job.status);
    return <tr key={job.id}>
      <td>{formatChinaDateTime(job.created_at)}</td><td><strong>{job.name}</strong></td>
      <td>{job.products.length} 个产品</td><td>{job.statistics.valid?.toLocaleString()}</td>
      <td><span className={`batch-status ${job.status.toLowerCase()}`}>{labels[job.status] || job.status}</span>
        {['QUEUED','RUNNING'].includes(job.status) && <><small>{progress}%</small><progress aria-label={`${job.name}查询进度`} value={done} max={total || 1}/></>}</td>
      <td>{Number(job.charged).toLocaleString('zh-CN',{style:'currency',currency:'CNY'})}</td>
      <td><button onClick={()=>onOpen(job)}>{job.status === 'TRIAL_DONE' ? '继续全量查询' : '查看进度'}</button>
        {downloadable && <div className="batch-download-files">{job.products.map(p=><button key={p.code} onClick={()=>onDownload(job,p.code,p.name)}>{p.name}.xlsx</button>)}</div>}</td>
    </tr>;
  })}</tbody></table>{!jobs.length && <p className="batch-empty">暂无批量查询记录</p>}</div>;
}
